import * as React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import AddLocationIcon from "@mui/icons-material/AddLocation";
import ArticleIcon from "@mui/icons-material/Article";
import PeopleIcon from "@mui/icons-material/People";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SchoolIcon from "@mui/icons-material/School";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useState } from "react";
import ReplayIcon from "@mui/icons-material/Replay";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

function getInitialRole() {
  const token = localStorage.getItem("token");
  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken?.claims?.role || "";
    } catch {
      return "";
    }
  }
  return localStorage.getItem("role") || "";
}

export default function ListItems() {
  // useState 和 useEffect 必须放在 React 组件内部
  const [userRole] = useState(getInitialRole);
  // 函数封装菜单项的显示逻辑
  const renderMenuItem = React.useCallback(
    (requiredRole, link, icon, label) => {
      // 如果用户角色是 ROLE_ICPIE 或者用户角色和菜单要求的角色匹配，则渲染菜单项
      if (userRole === "ROLE_ICPIE" || userRole === requiredRole) {
        return (
          <ListItemButton component={Link} to={link}>
            <ListItemIcon>{icon}</ListItemIcon>
            <ListItemText primary={label} />
          </ListItemButton>
        );
      }
      return null; // 如果用户角色不匹配，则返回 null 不渲染此菜单项
    },
    [userRole],
  );

  //  const handleKBClick=()=>{
  //   setOpenKB(!openKB);
  //   if(!openKB&&treeData.length===0){
  //     axiosInstance.get('/tag')
  //       .then((res)=>setTreeData(res.data))
  //       .catch((err)=>console.error('Falied to fetch KB tree',err));
  //   }
  //  };

  //  const renderTree=(nodes)=>(
  //     <TreeItem key={nodes.id} nodeId={nodes.id.toString()} label={nodes.name}>
  //       {Array.isArray(nodes.children)
  //         ?nodes.children.map((child)=>renderTree(child))
  //         :null

  //       }
  //     </TreeItem>
  //  );
  return (
    <React.Fragment>
      {/* 无需角色控制的菜单 */}
      <ListItemButton component={Link} to="/dashboard">
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItemButton>

      {/* 基于角色动态控制的菜单项 */}
      {renderMenuItem(
        "ROLE_ICPIS",
        "/venuemain",
        <AddLocationIcon />,
        "Venues",
      )}
      {renderMenuItem(
        "ROLE_ICPIS",
        "/instructormain",
        <PeopleIcon />,
        "Instructors",
      )}
      {renderMenuItem(
        "ROLE_ICPIS",
        "/ADCalendarMain",
        <CalendarMonthIcon />,
        "AD Calendar",
      )}
      {renderMenuItem(
        "ROLE_ICPIS",
        "/ADCalendarAHAMain",
        <CalendarMonthIcon />,
        "AD Calendar AHA",
      )}
      {/* AD Calendar 仅限 ROLE_ICPIE 用户 */}
      {renderMenuItem("ROLE_ICPIE", "/management", <PersonAddIcon />, "Management")}
      {(userRole === "ROLE_ICPIE" || userRole === "ROLE_ICPIS") && (
        <ListItemButton component={Link} to="/coursemain">
          <ListItemIcon>
            <SchoolIcon />
          </ListItemIcon>
          <ListItemText primary="Courses" />
        </ListItemButton>
      )}
      {renderMenuItem("ROLE_ICPIE", "/Repost", <ReplayIcon />, "Repost")}
      {renderMenuItem(
        "ROLE_ICPIE",
        "/ReportMain",
        <AssessmentIcon />,
        "Report",
      )}
      {renderMenuItem(
        "ROLE_ICPIE",
        "/CourseRecordMain",
        <LocalHospitalIcon />,
        "ARC Course Record",
      )}

      <ListItemButton component={Link} to={"/KBArticlesMain"}>
        <ListItemIcon>
          <ArticleIcon />
        </ListItemIcon>
        <ListItemText primary="KB" />
      </ListItemButton>
      {/* 
      {openKB&&(
        <TreeView
          defaultCollapseIcon={<ExpandLess/>}
          defaultExpandIcpn={<ExpandMore/>}
          sx={{pl:4}}>
            {treeData.map((node)=>renderTree(node))}
          </TreeView>
      )} */}
    </React.Fragment>
  );
}
// export const secondaryListItems = (
//   <React.Fragment>
//     <ListSubheader component="div" inset>
//       Saved reports
//     </ListSubheader>
//     <ListItemButton>
//       <ListItemIcon>
//         <TodayIcon />
//       </ListItemIcon>
//       <ListItemText primary="Current month" />
//     </ListItemButton>
//     <ListItemButton>
//       <ListItemIcon>
//         <EventIcon />
//       </ListItemIcon>
//       <ListItemText primary="Last month" />
//     </ListItemButton>
//     <ListItemButton>
//       <ListItemIcon>
//         <DateRangeIcon />
//       </ListItemIcon>
//       <ListItemText primary="Next month" />
//     </ListItemButton>
//   </React.Fragment>
// );
